import React, { Fragment, useCallback, useEffect, useMemo } from "react";

//devextreme
import Drawer from "devextreme-react/drawer"; //helpers
import { Operation, run, sleep } from "effection";
import Balancer from "react-wrap-balancer";

import { MENU_WIDTH } from "@app/components/drawer/background";
import AnyGrid from "@app/components/lists/lxr_anyGrid";
import InvoiceGrid from "@app/components/lists/lxr_invoiceGrid";
import { ListSelectionGroup } from "@app/components/lists/selectionForm";
//others
import {
  Case,
  CaseElse,
  HelpContextProvider,
  Switch,
  useWindowDimensions,
} from "@app/contexts";
import { MessageUnderConstruction } from "@app/pages/startup/VerificationRequired";
//state
import { useAppDispatch, useAppSelector } from "@app/state";
import {
  CONST_LISTORIGIN_AVOCATI,
  CONST_LISTORIGIN_CTRDOSARE,
  CONST_LISTORIGIN_INVOICE,
  CONST_LISTORIGIN_PROFORMA,
  CONST_LISTORIGIN_WORK,
  CONST_LSTORIGIN_CONTACTE,
  CONST_LSTORIGIN_CONTPERS_MD,
  CONST_LSTORIGIN_PERSOANE,
} from "@app/state/insider/constants";
import {
  selectListReportUi_loadedUi,
  selectListReportUi_tempUi,
  uiListTempUiSetMenuOpened_afterSync,
  uiListTempUiSetMenuOpened_withSyncOption,
} from "@app/state/insider/ui/uiList";
import "@app/style/dx.generic.jurnalKarma1.css";
import { TListOriginName } from "@app/types/insider";

import "./listMain.scss";

/* -------------------------------------------------------------------------- */
const Lists = () => {
  const dispatch = useAppDispatch();
  const theLoadedState = useAppSelector(selectListReportUi_loadedUi);
  const theCurrentlySelectingState = useAppSelector(selectListReportUi_tempUi);
  const {
    height: fullHeight,
    width: fullWidth,
    jgDrawerHeight,
  } = useWindowDimensions();

  const earlyMenuOpenedState = useMemo(() => {
    const earlyMenuOpenedState = Boolean(
      theCurrentlySelectingState?.MenuOpened
    );
    return earlyMenuOpenedState;
  }, [theCurrentlySelectingState]);

  const theSwitchValue = useMemo(() => {
    return theLoadedState?.lxReportName?.split("_@_AMA")?.[0] || "FALLBACK";
  }, [theLoadedState]);

  const anyListSelected = useMemo(() => {
    return [
      CONST_LSTORIGIN_CONTACTE,
      CONST_LSTORIGIN_PERSOANE,
      CONST_LISTORIGIN_CTRDOSARE,
      CONST_LSTORIGIN_CONTPERS_MD,
      CONST_LISTORIGIN_WORK,
      CONST_LISTORIGIN_AVOCATI,
      CONST_LISTORIGIN_PROFORMA,
      CONST_LISTORIGIN_INVOICE,
    ].includes(theSwitchValue as TListOriginName);
  }, [theLoadedState]);

  function* init(): Operation<void> {
    if (!theLoadedState?.lxReportName) {
      dispatch(
        uiListTempUiSetMenuOpened_afterSync({
          MenuOpened: true,
        })
      );
    }
    yield* sleep(0);
    return;
  }
  const initialize = useCallback((e: any) => {
    run(init);
    return e;
  }, []);

  function* closeMenu(): Operation<void> {
    dispatch(uiListTempUiSetMenuOpened_afterSync({ MenuOpened: "TOGGLE" }));
    yield* sleep(0);
    return;
  }
  const msg = [
    <Balancer key={1}>{"Rapoarte implementate pana acum:"}</Balancer>,
    <Balancer key={2}>{"1. Raportul de facturi emise"}</Balancer>,
    <span key={3} style={{ color: "gray" }}>
      {"urmeaza restul"}
    </span>,
  ];
  const Disclaimer = () => {
    return (
      <MessageUnderConstruction
        buttonVisible={true}
        buttonClick={() => run(closeMenu)}
      >
        {msg}
      </MessageUnderConstruction>
    );
  };
  return (
    <HelpContextProvider>
      <div id={"listPage"} ref={initialize}>
        <Drawer
          opened={anyListSelected ? earlyMenuOpenedState : true}
          openedStateMode={"overlap"}
          position={"left"}
          revealMode={"slide"}
          render={() => <ListSelectionGroup />}
          closeOnOutsideClick={false}
          height={(jgDrawerHeight ?? 4) - 4}
        >
          <div
            id={"importantwrapper"}
            // the width of the drawer + 1 the padding of importat-wrapper
            style={{
              maxWidth: `${(fullWidth || MENU_WIDTH + 1) - 153}px`,
              overflow: "auto",
            }}
          >
            <Switch value={theSwitchValue}>
              <Case when={CONST_LSTORIGIN_CONTACTE}>
                <AnyGrid listOrigin={CONST_LSTORIGIN_CONTACTE} />
              </Case>
              <Case when={CONST_LSTORIGIN_PERSOANE}>
                <AnyGrid listOrigin={CONST_LSTORIGIN_PERSOANE} />
              </Case>
              <Case when={CONST_LISTORIGIN_CTRDOSARE}>
                <AnyGrid listOrigin={CONST_LISTORIGIN_CTRDOSARE} />
              </Case>
              <Case when={CONST_LSTORIGIN_CONTPERS_MD}>
                <AnyGrid listOrigin={CONST_LSTORIGIN_CONTPERS_MD} />
              </Case>
              <Case when={CONST_LISTORIGIN_WORK}>
                <AnyGrid listOrigin={CONST_LISTORIGIN_WORK} />
              </Case>
              <Case when={CONST_LISTORIGIN_AVOCATI}>
                <AnyGrid listOrigin={CONST_LISTORIGIN_AVOCATI} />
              </Case>
              <Case when={CONST_LISTORIGIN_PROFORMA}>
                <InvoiceGrid listOrigin={CONST_LISTORIGIN_PROFORMA} />
              </Case>
              <Case when={CONST_LISTORIGIN_INVOICE}>
                <InvoiceGrid listOrigin={CONST_LISTORIGIN_INVOICE} />
              </Case>
              <CaseElse>
                {/* <Disclaimer /> */}
                <div />
              </CaseElse>
            </Switch>
          </div>
        </Drawer>
      </div>
    </HelpContextProvider>
  );
};

export default Lists;
